import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import MapSettings from './MapSettings';
import USMapChart from './USMapChart';
import { updateMapSettings } from '../../../actions/quickReportsActions';

const Maps = ({ handletitle, runReport }) => {
  const reportResult = useSelector(state => state.quickReports.reportResult)
  const mapSettings = useSelector(state => state.quickReports.mapSettings)
  const mapViews = Object.keys(reportResult.mapDetailGroups)
  const [view, setView] = useState(mapViews.length ? mapViews[0] : '')
  const [geoLabel, setGeoLabel] = useState(false);
  const [indexLabel, setIndexLabel] = useState(false);
  const dispatch = useDispatch()

  useEffect(() => {
    handletitle(`Geographies`);
  }, [])

  let mapData = reportResult.mapDetailGroups[view]
  const minIndex = mapData.indexGroups &&
    mapData.indexGroups[mapData.indexGroups.length -1].split('-')[0].trim()
  const maxIndex = mapData.indexGroups && mapData.indexGroups[0].split('-')[1].trim()

  const handleViewChange = view => {
    setView(view)
    mapData = reportResult.mapDetailGroups[view]
  }

  return (
    <div className="map">
      <MapSettings
        view={view}
        data={mapViews}
        handleViewChange={handleViewChange}
        mapSettings={mapSettings}
        runReport={runReport}
        geoLabel={geoLabel}
        indexLabel={indexLabel}
        setGeoLabel={setGeoLabel}
        setIndexLabel={setIndexLabel}
        indexRange={[minIndex, maxIndex]}
        updateMapSettings={(key, value) => dispatch(updateMapSettings(key, value))}
        dropdownListTitle="View"
      />
      <div className="map--chart">
        <USMapChart
          indexLabel={indexLabel}
          geoLabel={geoLabel}
          censusRegionData={mapData}
          view={view}
        />
        {/* <RegionMap
          indexLabel={indexLabel}
          geoLabel={geoLabel}
          censusRegionData={mapData}
          view={view}
          indexRange={indexRange}
        /> */}
      </div>
    </div>
  );
}

Maps.propTypes = {
  handletitle: PropTypes.func,
  runReport: PropTypes.func,
};

export default Maps
